import { observable, configure, action, computed } from 'mobx';
import LocalModel from './localModel';

import util from 'preact-util';
import { route } from 'preact-router';
import PubSub, { topics } from '../lib/pubsub';

configure({ enforceActions: 'always' });

class LikeStore extends LocalModel {
    constructor() {
        super('like', {
            namePlural: 'likes',
            namePluralReal: 'likes',
            sort: 'createdDate',
            limit: 500,
            api: {
                search: {
                    url: '/api/likes/',
                    params: {
                        limit: 50,
                        sort: 'lastname',
                    },
                },
                load: {
                    url: '/api/likes/',
                    params: {},
                },
                save: {
                    url: '/api/likes/',
                    params: {},
                },
                delete: {
                    url: '/api/likes/',
                    params: {},
                },
            },
        });
    }

    @observable newLike = {};

    @observable like = {};

    @observable likes = [];

    @action
    async changeReaction({ type, objectId, likeType }) {
        const response = await util.fetchApi('/api/likes/', { method: 'PATCH' }, { type, objectId, likeType });
        return response;
    }

}

const store = new LikeStore();
export default store;

// Named export for the class itself
export { LikeStore };
